package com.neurobs.ccabserver.administrator.contexts

import com.neurobs.react.ContextBase
import com.neurobs.util.{Logger, NullLogger}

object LoggerContext extends ContextBase[Logger] {
	override protected def defaultStateValue(): Logger = new NullLogger
}
